import React, { useState } from 'react';
import {
    useRecordContext,
    useCreate,
    Confirm,
    useNotify,
    useRedirect
} from 'react-admin';

import CalculateIcon from '@mui/icons-material/Calculate';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { startActionButtonCss } from '../shared/Styles/buttonStyles';

export const CalcolaButtonBox = ({ titolo, messaggio, servizio, redirectPath }) => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();

    const [create, { isLoading }] = useCreate();

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {
        if (record && record.id) {
            create(servizio,
                { data: { tblQuizId: record.id } },
                {
                    onSuccess: () => {
                        notify('Calcolo eseguito con successo', 'info');
                        window.location.reload();  // Esegue il refresh della pagina
                    },
                    onFailure: (error) => {
                        notify(`Errore: ${error.message}`, 'warning');
                    }
                });
        }
        setOpen(false);
    };

    if (!record || !record.id) {
        return null;
    }

    return (
        <>
            {isLoading ? (
                <CircularProgress size={24} sx={{ color: '#e85a2c' }} />
            ) : (
                <Button
                    sx={startActionButtonCss}
                    onClick={handleClick}
                    variant="contained"
                    size="small"
                    endIcon={<CalculateIcon />}
                    component="label"
                >
                    Calcola Punteggio
                </Button>
            )}
            <Confirm
                isOpen={open}
                loading={isLoading}
                title={titolo || "Esegui operazione di calcolo"}
                content={messaggio}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
                confirm="Si"
                cancel="No"
            />
        </>
    );
};
